import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

const Certifications = () => {
  return (
    <section className="page-shell flex min-h-screen items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="page-panel flex w-full max-w-4xl flex-col items-center gap-10 rounded-3xl p-8 md:flex-row md:p-12"
      >
        {/* Text Section */}
        <div className="flex-1 space-y-4">
          <p className="section-kicker text-xs font-semibold uppercase tracking-[0.22em]">
            Credential
          </p>
          <h2 className="section-title text-3xl font-bold md:text-4xl">
            Certifications
          </h2>

          <div className="page-card space-y-2 rounded-2xl p-5">
            <h3 className="section-title text-lg font-semibold">
              AWS Certified Developer – Associate
            </h3>
            <p className="body-copy text-sm leading-7">
              Issued: 12/2023 <br />
              Validation ID: <span className="font-mono">BQ3THVCBQ211Q0WN</span>
            </p>
            <a
              href="https://www.credly.com/badges/2e471ea3-2721-4887-a486-c7a6feff9286/linked_in_profile"
              target="_blank"
              rel="noopener noreferrer"
              className="section-kicker inline-flex items-center gap-1 text-sm font-semibold transition hover:opacity-80"
            >
              View on Credly
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Badge Image */}
        <div className="w-full md:w-1/3 flex justify-center">
          <img
            src="/logos/aws-cert-badge.png"
            alt="AWS Certified Developer Badge"
            className="w-40 h-auto object-contain"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Certifications;
